import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CodedResponseModel } from "src/app/model/CodedResponseModel";
import { Assessment } from "src/app/model/responsible/Assessment";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn:'root'
})
export class AssessmentAPI{
    constructor(
        private http:HttpClient,
    ){}

    public initAssessment(id:number){
        return this.http.post<CodedResponseModel>(`${environment.apiUrl}applications/${id}/assess`, null);
    }
    public autosave(id:number, data:Assessment){
        return this.http.put<CodedResponseModel>(`${environment.apiUrl}assessment/${id}/autosave`,
            data.responsify());
    }
    public assess(id:number, data:Assessment){
        return this.http.put<CodedResponseModel>(`${environment.apiUrl}applications/${id}/assess`,
            data.responsify());
    }
    public massAssess(ids:number[], assessment:Assessment){
        return this.http.post<CodedResponseModel>(`${environment.apiUrl}applications/bulkAssess`,
            { ids:ids, assess:assessment });
    }

    public getPdf(id:number){
        return this.http.get<CodedResponseModel>(`${environment.apiUrl}assessment/pdf?application=${id}`);
    }
}
